export class CacheController {
  /* @ngInject */
  constructor($state, previousState, $cacheFactory) {
    this.$state = $state;
    this.$cacheFactory = $cacheFactory;
    this.$cacheFactory.get('$http').removeAll();
    previousState.name && this.$state.go(previousState.name, previousState.params);
  }
}


/** WEBPACK FOOTER **
 ** ./src/common/appLifeCycle/emptyCache.js
 **/